import DataHelper from './dataHelper';
/**
 * Helper function that can be used to update the apollo data cache, intended to maintain the userprofile query in one place.
 * Not intended to have any getters, Should use DataHelper instead.
 * @param {object} draftData - mutable proxied data object resulted from produce() function https://immerjs.github.io/immer/produce/
 * @param {boolean} userThumbnailsEnabled - boolean to determine if userThumbnails field should be used instead of thumbnails
 * @returns {object} - an object with the setter functions exposed
 * @example
 * const { setProfileImage, setIsImagePresent, setFirstLastName } = DataCacheHelper(draftData, userThumbnailsEnabled)
 */
export default function DataCacheHelper(draftData, userThumbnailsEnabled = false) {
  const { personalInfo, profileImages } = DataHelper(draftData, userThumbnailsEnabled);

  const setProfileImage = (imageUrl) => {
    if (profileImages) {
      const selectedThumbnails = userThumbnailsEnabled ? profileImages.userThumbnails : profileImages.thumbnails;
      
      if (selectedThumbnails) {
        selectedThumbnails.sizeX120 = imageUrl;
      }
    }
  };

  const setIsImagePresent = (isImage) => {
    if (profileImages) {
      profileImages.isImagePresent = isImage;
    }
  };

  const setFirstLastName = (firstname, lastname) => {
    if (personalInfo) {
      personalInfo.basicInfo.firstName = firstname;
      personalInfo.basicInfo.lastName = lastname;
    }
  };

  const setAboutMeText = (aboutMe) => {
    if (personalInfo) {
      personalInfo.aboutMe = aboutMe;
    }
  };

  const setAlternateEmail = (email) => {
    if (personalInfo) {
      personalInfo.contactInfo.alternateEmail = email;
    }
  };

  const setPhoneData = (phones) => {
    if (personalInfo) {
      personalInfo.contactInfo.phones = phones;
    }
  };

  const setAddress = (addressLine1, addressLine2, city, stateProvince, postalCode, country) => {
    if (personalInfo) {
      const address = personalInfo.contactInfo.address;
      address.addressLine1 = addressLine1;
      address.addressLine2 = addressLine2;
      address.city = city;
      address.stateProvince = stateProvince;
      address.postalCode = postalCode;
      address.country = country;
    }
  }

  const setIndustry = (industry) => {
    if (personalInfo) {
      personalInfo.professionalInfo.additionalProfessionalInfo.industryTaxonomyIds =
        industry;
    }
  };

  const setRole = (roleId, roleName) => {
    if (personalInfo) {
      personalInfo.professionalInfo.additionalProfessionalInfo.roleId = roleId;
      personalInfo.professionalInfo.jobTitle = roleName;
    }
  };

  const setWebsite = (website) => {
    if (personalInfo) {
      personalInfo.webLinks.website = website;
    }
  };

  const setBlog = (blog) => {
    if (personalInfo) {
      personalInfo.webLinks.blog = blog;
    }
  };

  const setLinkedIn = (linkedIn) => {
    if (personalInfo) {
      personalInfo.webLinks.linkedInProfile = linkedIn;
    }
  };

  const setCompanyName = (companyName) => {
    if (personalInfo) {
      personalInfo.professionalInfo.company.companyName = companyName;
    }
  };

  const setLanguage = (language) => {
    if (personalInfo) {
      personalInfo.language = language;
    }
  };

  return {
    setIsImagePresent,
    setProfileImage,
    setFirstLastName,
    setAboutMeText,
    setAlternateEmail,
    setPhoneData,
    setIndustry,
    setRole,
    setWebsite,
    setBlog,
    setLinkedIn,
    setCompanyName,
    setLanguage,
    setAddress,
  };
}
